// extracted by mini-css-extract-plugin
module.exports = {"subtotal-loader":"fbt-subtotal_subtotal-loader__ZJlIh","price":"fbt-subtotal_price__m_e1N"};